import { Dialog, Drawer } from 'element-ui'

const DialogPatch = {
  extends: Dialog,
  data() {
    return { mouseDowned: false }
  },
  mounted() {
    this.$el.onmousedown = (e) => {
      this.mouseDowned = e.target.classList.contains('el-dialog__wrapper')
    }
  },
  methods: {
    handleWrapperClick() {
      if (!this.closeOnClickModal || !this.mouseDowned) return
      this.handleClose()
    },
  },
}
const DrawerPatch = {
  extends: Drawer,
  data() {
    return { mouseDowned: false }
  },
  mounted() {
    this.$el.onmousedown = (e) => {
      this.mouseDowned = e.target.classList.contains('el-drawer__container')
    }
  },
  methods: {
    handleWrapperClick() {
      if (!this.wrapperClosable || !this.mouseDowned) return
      this.closeDrawer()
    },
  },
}

export default {
  install(Vue) {
    Vue.component(Dialog.name, DialogPatch)
    Vue.component(Drawer.name, DrawerPatch)
  },
}
